var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('feather',{staticClass:"text-info observations",attrs:{"id":_vm.id,"type":"info"}}),(_vm.tooltipText)?_c('b-tooltip',{attrs:{"custom-class":"observations-tooltip","target":_vm.id,"placement":"bottom"}},[_vm._v(_vm._s(_vm.tooltipText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }